export const REGISTER_SENDER_STORAGE_KEY = 'registerSender';
export const SESSION_TOKEN_STORAGE_KEY = 'X-Olimpo-Sessiontoken';
